import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../reducers";

// Basic selectors
export const selectSelectedCategoryId = (state: RootState) =>
  state.category.selectedCategoryId;

// Check if category is selected
export const selectIsCategorySelected = createSelector(
  [selectSelectedCategoryId, (_state: RootState, categoryId: string) => categoryId],
  (selectedId, categoryId) => selectedId === categoryId
);

// Check if any category is selected
export const selectHasSelectedCategory = createSelector(
  [selectSelectedCategoryId],
  (selectedId) => selectedId !== null
);
